"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = exports.resolveNestedJarsOption = exports.isStrictNumber = exports.isNumber = exports.isTrue = void 0;
function isTrue(value) {
    return String(value).toLowerCase() === "true";
}
exports.isTrue = isTrue;
// This strictly follows the ECMAScript Language Specification: https://262.ecma-international.org/5.1/#sec-9.3
function isNumber(value) {
    return !isNaN(Number(value));
}
exports.isNumber = isNumber;
// Must be a finite numeric value, excluding booleans, Infinity, and non-numeric strings
function isStrictNumber(value) {
    if (typeof value === "boolean" || !(value === null || value === void 0 ? void 0 : value.trim().length)) {
        return false;
    }
    const num = Number(value);
    return Number.isFinite(num);
}
exports.isStrictNumber = isStrictNumber;
function resolveNestedJarsOption(options) {
    const safeOptions = options || {};
    return [
        safeOptions["nested-jars-depth"],
        safeOptions["shaded-jars-depth"],
    ].find(isDefined);
}
exports.resolveNestedJarsOption = resolveNestedJarsOption;
function isDefined(value) {
    return value !== "" && value != null;
}
exports.isDefined = isDefined;
//# sourceMappingURL=option-utils.js.map